import React from 'react';
import { useNavigate } from "react-router-dom";

import { AppContext } from '../../context/AppContext';
import { Button, Headline, Richtext, Image } from '../../elements';
import { Layout } from '../../components';

import { sizes } from '../../data/options.json';
import styles from './SuccessPage.module.scss';

import { RESET } from '../../context/ActionTypes';
import { ROOT } from '../../navigation/routes';

import HERO_SUCCESS from '../../assets/images/hero_success.jpg';
import HERO_SUCCESS_LOW from '../../assets/images/hero_success_low.jpg';

const SuccessPage = () => {
    const { state, dispatch } = React.useContext(AppContext);
    const navigate = useNavigate();

    const findSizeLabel = (sizeValue) => {
        return sizeValue ? sizes.find((item) => item.value === sizeValue).label : '';
    }

    const handleNewConfiguration = () => {
        dispatch({ type: RESET });
        navigate(ROOT, { replace: true });
    }

    return (
        <Layout noPadding={true} >
            <div className={styles.imageWrapper}>
                <Image src={HERO_SUCCESS} placeholder={HERO_SUCCESS_LOW} width='544' height='400' />
            </div>

            <div className={styles.pageContainer}>
                <div className={styles.section}>
                    <Headline variant='h2'>Produkt-Konfiguration</Headline>
                    {state.configuration.elevators.map((item, index) => (
                        <React.Fragment key={`rte_${index}`}>
                            <Richtext additionalClass={styles.rteWrapper}>
                                <div className={styles.sectionRow}><span>Aufzug:</span> <span>{item.display_name}</span></div>
                                <div className={styles.sectionRow}><span>Produkt:</span> <span>{item.product.name} <br /> {findSizeLabel(item.product.size)}</span></div>
                            </Richtext>
                        </React.Fragment>
                    ))}
                </div>

                <Headline variant='h2'>Anfrage versendet</Headline>
                <Richtext>
                    <p>
                        Vielen Dank für Ihre Anfrage. Wir melden uns zeitnah bei Ihnen mit Informationen zu Ihrem gewünschten Produkt.
                    </p>
                </Richtext>

                <div className={styles.buttonWrapper}>
                    <Button title="Neue Konfiguration" onClick={() => handleNewConfiguration()} />
                </div>
            </div>


        </Layout>
    )
}

export default SuccessPage;
